import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addFolderFailure,
  addFolderSuccess,
  deleteFolderFailure,
  //
  deleteFolderSuccess,
  editFolderFailure,
  //
  editFolderSuccess,
  fetchContentFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  updateContentFiles,
  updateContentFolders,
  uploadFileFailure,
  uploadFileSuccess,
  validateFileFailure,
  validateFileSuccess,
} from "./actions";
import {
  ADD_FOLDER,
  DELETE_FOLDER,
  EDIT_FOLDER,
  FETCH_CONTENT,
  GET_VIEW_DATA,
  UPLOAD_FILE,
  VALIDATE_FILE,
} from "./constants";

export function* fetchContentSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, filters } = payload;
  let query = filters ? QueryString.stringify(filters) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/get-all-content/${id}?${query}`
    );
    yield put(updateContentFolders(data?.folders));
    yield put(updateContentFiles(data?.files));
  } catch (e) {
    yield put(fetchContentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching comment list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/feed-comment/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching terminal data!"));
  }
}

export function* addFolderSaga({ payload, onAdd }) {
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/create-folder/${companyId}`,
      payload
    );
    if (data) {
      yield put(addFolderSuccess());
      typeof onAdd === "function" && onAdd(data);
    }
  } catch (e) {
    yield put(addFolderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editFolderSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/feed-comment/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Folder updated successfully!"));
      yield put(editFolderSuccess());
      typeof onEdit === "function" && onEdit(data);
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editFolderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteFolderSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  let query = payload.data ? QueryString.stringify(payload.data) : "";
  try {
    const data = yield call(
      api(token).delete,
      `/api/delete-${payload?.type}/${companyId}?${query}`
    );
    if (data) {
      yield put(successAlert(`${payload.title} deleted successfully!`));
      yield put(deleteFolderSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteFolderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* uploadFileSaga({ payload, onUpload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  try {
    const { data } = yield call(
      api(token).post,
      `/api/file-upload/${companyId}`,
      payload
    );
    if (data) {
      yield put(successAlert("File uploaded successfully!"));
      yield put(uploadFileSuccess());
      typeof onUpload === "function" && onUpload(data);
    }
  } catch (e) {
    yield put(uploadFileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* validateFileSaga({ payload, onValidate }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const companyId = yield select(
    (state) => state?.AuthReducer?.user?.company_id
  );
  try {
    const data = yield call(
      api(token).post,
      `/api/check-file-upload-validation/${companyId}`,
      payload
    );
    if (data) {
      typeof onValidate === "function" && onValidate(false);
    }
    yield put(validateFileSuccess());
  } catch (e) {
    typeof onValidate === "function" &&
      onValidate(true, e?.response?.data?.message);
    yield put(validateFileFailure());
  }
}

export function* fetchContentFlow() {
  yield takeEvery(FETCH_CONTENT, fetchContentSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addFolderFlow() {
  yield takeEvery(ADD_FOLDER, addFolderSaga);
}
export function* editFolderFlow() {
  yield takeEvery(EDIT_FOLDER, editFolderSaga);
}
export function* deleteFolderFlow() {
  yield takeEvery(DELETE_FOLDER, deleteFolderSaga);
}
export function* uploadFileFlow() {
  yield takeEvery(UPLOAD_FILE, uploadFileSaga);
}
export function* validateFileFlow() {
  yield takeEvery(VALIDATE_FILE, validateFileSaga);
}

export default function* FolderSaga() {
  yield all([
    fetchContentFlow(),
    addFolderFlow(),
    editFolderFlow(),
    deleteFolderFlow(),
    getViewDataFlow(),
    uploadFileFlow(),
    validateFileFlow(),
  ]);
}
